module.exports = __webpack_public_path__ + "5b2e2f727b850b65198c49ecd79bee7f.svg";